import React, { useCallback, useMemo, useState } from 'react';
import { Button, Input, Col, IconButton } from '@commonsku/styles';
import AddButton from '../misc/AddButton';
import useConfirmDelete from '../hooks/useConfirmDelete';

export default function CompanyImprint({ item, saveItem, deleteItem }) {
    const [showForm, setShowForm] = useState(false);
    const defaultValues = useMemo(() => ({
        imprint_name: '',
        imprint_id: '',
    }), []);

    const [form, setForm] = useState(item || defaultValues);
    const [formErrors, setFormErrors] = useState(defaultValues);
    const [deletePopup, setPopupOpen, setDeleteItem] = useConfirmDelete({ deleteItemCallback: deleteItem });

    const setFormFieldValue = useCallback((e) => {
        const target = e.target;
        setForm((form) => ({ ...form, [target.name]: target.value }));
    }, []);

    const validateForm = useCallback((data) => {
        setFormErrors(defaultValues);
        let errorCount = 0;
        // Check data and set form errors
        for (const field of ['imprint_name']) {
            if (data[field].trim() === '') {
                setFormErrors((errors) => ({ ...errors, [field]: 'Required' }));
                errorCount++;
            }
        }

        if (errorCount > 0) return false;

        return true;
    }, [defaultValues]);

    const saveForm = useCallback(() => {
        if (!validateForm(form)) {
            return;
        }
        if (!item) {
            setForm(defaultValues);
            setShowForm(false);
        }
        saveItem({ ...item, ...form });
    }, [defaultValues, form, item, saveItem, validateForm]);

    const getTextInput = (field, col = 4) => {
        const hasError = formErrors[field] !== '';
        return (
            <Col padded sm={col}>
                <Input style={{ marginBottom: '0' }} name={field} value={form[field]} onChange={setFormFieldValue} onBlur={item ? saveForm : null} />
                {hasError ? <span style={{ color: 'red' }}>{formErrors[field]}</span> : ''}
            </Col>
        );
    };

    let formFields = (
        <>
            {getTextInput('imprint_name', 11)}

            {!item ?
                (<Col padded sm={1} style={{ textAlign: 'left' }} >
                    <Button size='small' onClick={saveForm}>{item ? 'Save' : 'Add'}</Button>
                </Col>)
                : null}

            {item ?
                <Col padded sm={1} style={{ textAlign: 'left', paddingLeft: '1rem' }} >
                    <IconButton preset='delete' onClick={() => {
                        setDeleteItem(item);
                        setPopupOpen(true);
                    }} />
                </Col>
                : <Col sm={1}></Col>}
            {deletePopup}
        </>
    );

    if (!item && !showForm) {
        formFields = <Col padded sm={12} style={{ textAlign: 'center' }}>
            <Button className='add-button' onClick={() => { setShowForm(true); }}>
                <AddButton />
            </Button>
        </Col>;
    }

    return formFields;
}
